import { makeStyles, Theme } from '@material-ui/core';
import React from 'react';

interface StyleProps {
  width: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: 'auto',
    width: (props: StyleProps) => props.width,
    [theme.breakpoints.only('xs')]: {
      width: '100%!important',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
}));

interface OnboardingFormLayoutProps {
  width?: number;
  children?: React.ReactNode;
}

const OnboardingFormLayout: React.FC<OnboardingFormLayoutProps> = ({
  width = 460,
  children,
}) => {
  const classes = useStyles({ width });

  return <div className={classes.root}>{children}</div>;
};

export default OnboardingFormLayout;
